import { useState, useEffect, useRef } from 'react';

const SCROLL_TOP_THRESHOLD = 60;
const SCROLL_END_DELAY_MS = 1000;

/**
 * Oculta la navbar al hacer scroll; tras 1s sin scroll la muestra en modo compacto (sin logo, menos altura).
 * Cerca del top de la página siempre se muestra la navbar completa.
 */
export function useNavbarScroll() {
  const [hidden, setHidden] = useState(false);
  const [compact, setCompact] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      if (y < SCROLL_TOP_THRESHOLD) {
        setHidden(false);
        setCompact(false);
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        return;
      }
      setHidden(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setHidden(false);
        setCompact(true);
        timeoutRef.current = null;
      }, SCROLL_END_DELAY_MS);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return { hidden, compact };
}
